import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=8dccea3c&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=8dccea3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dccea3c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8dccea3c')) {
      api.createRecord('8dccea3c', component.options)
    } else {
      api.reload('8dccea3c', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=8dccea3c&scoped=true&", function () {
      api.rerender('8dccea3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2CoJbqtkQ3exd/JS/comp/SearchFilterTokens.vue"
export default component.exports